import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "@/store";
import {
  Overlay,
  Modal,
  Title,
  Body,
  Controls,
  CheckboxLabel,
  Button,
} from "./styled";

/* ===============================
   Cookie Helpers
   =============================== */

const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(
    value
  )};expires=${expires.toUTCString()};path=/`;
};

const hasCookie = (name) =>
  document.cookie
    .split("; ")
    .some((row) => row.startsWith(name + "="));

/* ===============================
   Component
   =============================== */

const NotificationModal = () => {
  const dispatch = useDispatch();

  const { activeNotifications } = useSelector((state) => state.notifications);

  const [visibleNotifications, setVisibleNotifications] = useState([]);
  const [dismissForever, setDismissForever] = useState({});

  useEffect(() => {
    dispatch(notificationActions.getActiveNotifications());
  }, [dispatch]);

  useEffect(() => {
    const filtered =
      activeNotifications?.filter((n) => {
        const cookieKey = `notification_${n.id}`;
        return !hasCookie(cookieKey);
      }) ?? [];

    setVisibleNotifications(filtered);
  }, [activeNotifications]);

  const dismiss = (id) => {
    const cookieKey = `notification_${id}`;

    const notification = activeNotifications?.find((n) => n.id === id);

    let expiresAt;

    if (dismissForever[id] && notification?.endDate) {
      expiresAt = new Date(`${notification.endDate}Z`);
    } else {
      expiresAt = new Date(Date.now() + 24 * 60 * 60 * 1000);
    }

    setCookieWithExpiry(cookieKey, "dismissed notification", expiresAt);

    setVisibleNotifications((prev) =>
      prev.filter((n) => n.id !== id)
    );
  };

  const setCookieWithExpiry = (name, value, expiresAt) => {
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expiresAt.toUTCString()};path=/`;
  };

  const toggleForever = (id) => {
    setDismissForever((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  if (!visibleNotifications.length) return null;

  return (
    <>
      {visibleNotifications.map((n) => (
        <Overlay key={n.id}>
          <Modal>
            <Title>{n.title}</Title>

            <Body>{n.body}</Body>

            <Controls>
              <CheckboxLabel>
                <input
                  type="checkbox"
                  checked={!!dismissForever[n.id]}
                  onChange={() => toggleForever(n.id, n.endDate)}
                />
                Don't show this again
              </CheckboxLabel>

              <Button
                className="primary-antd-button"
                primary
                onClick={() => dismiss(n.id)}
              >
                OK
              </Button>
            </Controls>
          </Modal>
        </Overlay>
      ))}
    </>
  );
};

export default NotificationModal;